var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"main"},[_c('h1',{staticClass:"page-title"},[_vm._v("404 - Not Found")]),_c('p',[_vm._v(" Return to "),_c('router-link',{attrs:{"to":{name: 'home'}}},[_vm._v("home")]),_vm._v(". ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }